import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { insertPlaceholderCards } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/heroAndText/helpers/HeroAndTextLayoutLandscape';
import { Dimensions } from 'react-native';

import type {
  HeroAndTextView,
  HeroAndTextViewStyles,
  ImagePartSizes,
} from '../../common/MultiSectionView.types';
import { getMediaType } from './HeroAndTextLayout';
import { getTextPartPortrait } from './HeroAndTextLayoutPortrait.textPart';

const HERO_ASPECT_RATIO = 0.8;

export const layoutHeroAndTextPortrait = async ({
  section,
  viewData,
}: {
  section: HeroAndTextView;
  viewData: ViewData;
}) => {
  const styles = await getBoxLayoutPortraitHeroText(section);
  insertPlaceholderCards(styles, viewData, section);
};

export const getBoxLayoutPortraitHeroText = async (
  section: HeroAndTextView
): Promise<HeroAndTextViewStyles> => {
  const { imagePartSize, imageSize } = getImagePartSize();

  return {
    layout: 'portrait',
    imagePart: {
      size: imagePartSize,
      imageSize,
      mediaType: getMediaType(),
      radius: 15,
      imagePosition: { x: 0, y: 0 },
    },
    textPart: await getTextPartPortrait(section),
  };
};

const getImagePartSize = (): ImagePartSizes => {
  const { width: windowWidth } = Dimensions.get('window');
  const imageSize: PlaneSize = {
    width: windowWidth,
    height: windowWidth / HERO_ASPECT_RATIO,
  };

  return {
    imagePartSize: imageSize,
    imageSize,
  };
};
